<div
  class="shadow-xs flex size-full flex-col justify-between rounded-lg border border-grey-lightGrey px-6 py-5"
  *transloco="let t"
>
  <div class="flex w-full justify-between">
    <div class="flex flex-col gap-1">
      <p class="text-base font-semibold">
        {{ t('portal.subscription.licenses.totalLicensesText') }}:
      </p>
      <div class="flex items-center">
        <mat-icon class="p-1 text-xs text-orange-500">circle</mat-icon>
        <span class="ml-2 text-base font-normal text-grey">
          {{ t('portal.subscription.licenses.availableLicensesText') }}:
        </span>
      </div>
      <div class="flex items-center">
        <mat-icon class="p-1 text-xs text-grey-lightGrey">circle</mat-icon>
        <span class="ml-2 text-base font-normal text-grey">
          {{ t('portal.subscription.licenses.assignedLicensesText') }}:
        </span>
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <p class="text-base font-bold text-grey">
        {{ totalLicensesCount$ | async }}
      </p>
      <p class="text-base font-bold text-grey">
        {{ availableLicensesCount$ | async }}
      </p>
      @if (assignedLicensesCount$ | async; as assignedLicensesCount) {
        <p class="flex items-center text-base font-bold text-grey">
          {{ assignedLicensesCount }}
          <mat-icon
            class="material-icons-outlined ml-1 cursor-pointer text-base text-grey-midGrey"
            [matTooltip]="
              t('portal.subscription.licenses.assignedLicensesTooltipText', {
                assignedLicenses: assignedLicensesCount$ | async,
                reservedLicenses: reservedLicensesCount$ | async,
              })
            "
            matTooltipPosition="above"
            matTooltipClass="tooltip-above"
          >
            help_outline
          </mat-icon>
        </p>
      }
    </div>
  </div>
  <div class="pt-4">
    @if (
      availableToTotalLicensesRatio$ | async;
      as availableToTotalLicensesRatio
    ) {
      <app-sep-bar-chart
        [percentage]="availableToTotalLicensesRatio"
      ></app-sep-bar-chart>
    }
  </div>
  @if (!freeTrial) {
    <div class="mt-4">
      <app-text-button (click)="addLicensesButtonClickEvent.emit()">{{
        t('portal.subscription.licenses.addLicensesButtonText')
      }}</app-text-button>
    </div>
  }
</div>
